import React from "react";
import { FormattedMessage } from "react-intl";
export const REQUIRED = (<FormattedMessage id="forms.messages.required" defaultMessage="Required"/>);
export const INVALID = (<FormattedMessage id="forms.messages.invalid" defaultMessage="Invalid"/>);
/* Errors for tComb Form input types */
export const ERRORS = {
    EMAIL: (<FormattedMessage id="forms.messages.errors.email" defaultMessage="Please enter a valid email address"/>),
    GLOBAL: (<FormattedMessage id="forms.messages.errors.global" defaultMessage="The form was not submitted. Please correct the errors."/>),
    PHONE: (<FormattedMessage id="forms.messages.errors.phone" defaultMessage="Please enter a valid phone number"/>),
    SELECT: (<FormattedMessage id="forms.messages.errors.select" defaultMessage="Please select an option"/>),
    STATE: (<FormattedMessage id="forms.messages.errors.state" defaultMessage="Please enter a valid state abbreviation"/>),
    ZIP: (<FormattedMessage id="forms.messages.errors.zip" defaultMessage="Invalid"/>),
    ACCOUNT_NUMBER: (<FormattedMessage id="forms.messages.errors.accountNumber" defaultMessage="Please enter a valid account number"/>)
};



// WEBPACK FOOTER //
// ./src/assets/scripts/constants/FormMessages.tsx